import { DisplayTokenFragment, ExhibitionArtistItemFragment } from '@/gql/generated/graphql'
import { AllPurposeLink } from '@components/all-purpose-link'
import { artistRoute } from '@utils/routes'
import { BodyText, HeadlineText, JumboText, LeftArrowIcon } from 'design-configuration/components'
import React from 'react'
import { ExhibitionImageCurl } from './exhibition-image-curl'
import { TrackedButtonNames, trackButtonClicked } from '@utils/analytics'

export type ExhibitionArtist = {
  artist?: ExhibitionArtistItemFragment | null
  featuredToken?: DisplayTokenFragment | null
}

export const ExhibitionArtistSection = ({
  artistDisplayInfo
}: {
  artistDisplayInfo: {
    image1: string
    image2: string
    image3?: string | null
    content: React.ReactElement
    align: string
    fullArtistDetails: ExhibitionArtist
  }[]
}): React.ReactElement => {
  return (
    <div className="mb-[80px] w-full lg:mb-[128px]">
      <JumboText className="px-md md:pb-xl pb-md font-medium">The artists</JumboText>
      <div className="flex w-full flex-col gap-y-[80px] lg:gap-y-[128px]">
        {artistDisplayInfo.map((displayInfo) => (
          <div key={`${displayInfo.fullArtistDetails?.artist?.slug}`}>
            <ExhibitionImageCurl
              image1AspectRatio="aspect-[4/5]"
              align={displayInfo.align as 'left' | 'right'}
              content={
                <div>
                  <HeadlineText>{displayInfo.fullArtistDetails?.artist?.artistName}</HeadlineText>
                  {displayInfo.content}
                  <AllPurposeLink
                    className="gap-x-2xs flex flex-row items-center"
                    href={artistRoute(displayInfo.fullArtistDetails.artist?.slug ?? '')}
                    onClick={() => {
                      trackButtonClicked(TrackedButtonNames.exhibitionArtistLearnMore, {
                        customProperties: {
                          'Artist name': displayInfo.fullArtistDetails?.artist?.artistName,
                          Slug: displayInfo.fullArtistDetails?.artist?.slug
                        }
                      })
                    }}
                  >
                    <BodyText>Learn more</BodyText>
                    <LeftArrowIcon className="rotate-180" />
                  </AllPurposeLink>
                </div>
              }
              image1={displayInfo.image1}
              image2={displayInfo.image2}
              image3={displayInfo.image3 ?? ''}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
